import React, { useState, useEffect } from "react";
import "../styles/Home.css";



const Home = () => {
  const [showScrollButton, setShowScrollButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setShowScrollButton(true);
      } else {
        setShowScrollButton(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="home-page">



      <div className="container text-animation-container">
        <div className="animated-text">
          <div className=".container.visible ">
          </div>
          Welcome to SSB Academy - Your Gateway to Success!

        </div>
      </div>

 
      <div className="bg-image-containerhome">
        {/* <div className="centered-text">
          Prepare for Excellence
        </div> */}
      </div>

   
      <div className="image-text-container">
      <div className="bg-image">


        </div>
        <div className="text-section">
          <h2>Our Training Programs</h2>
          <p>
          We offer comprehensive training programs designed to help you succeed in the SSB interview process. Whether you're aiming for the Army, Navy, Air Force, or other defense sectors, our expert trainers and time-tested methodologies ensure your preparedness.

Our training programs cover all aspects of the SSB interview, from the psychological tests and group discussions to the personal interview and physical fitness. Each program is tailored to meet your specific needs, with personalized attention to help you improve your weak areas.
          </p>
        </div>
      </div>

<div className="whycontainer">
      <div className="text-container">
        <div className="main-text">
          Why Choose SSB Academy?
        </div>
        <div className="additional-line">
          Experienced Trainers | Proven Results | Personalized Guidance
        </div>
      </div>


<div className="text-container1">
 
 


  <div className="step-by-step">
    <ul>
      <li><strong>Experienced Trainers:</strong> Our trainers have years of experience and expertise in guiding candidates through the SSB process.</li>
      <li><strong>Proven Results:</strong> Many of our students have successfully cracked the SSB interview, thanks to our comprehensive training programs.</li>
      <li><strong>Personalized Guidance:</strong> We tailor our training to suit each candidate's needs, ensuring the best possible outcome for each individual.</li>
      <li><strong>Mock Interviews:</strong> We conduct mock interviews that simulate the actual SSB environment, preparing candidates for the real experience.</li>
      <li><strong>Physical Fitness:</strong> Our training includes physical fitness sessions to ensure candidates are physically prepared for the SSB process.</li>
    </ul>
  </div>
</div>
</div>


     
      <div className="testimonials-container">
        <h2>What Our Students Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p>"SSB Academy helped me crack my interview on the first attempt. Highly recommended!"</p>
            <p className="testimonial-author">- John Doe</p>
          </div>
          <div className="testimonial-card">
            <p>"The trainers are amazing, and the study material is top-notch."</p>
            <p className="testimonial-author">- Jane Smith</p>
          </div>
          <div className="testimonial-card">
            <p>"I couldn't have done it without SSB Academy. Thank you!"</p>
            <p className="testimonial-author">- Alex Johnson</p>
          </div>
        </div>
      </div>


      {showScrollButton && (
        <div className="scroll-to-top">
          <button onClick={scrollToTop}>
            ↑
          </button>
        </div>
      )}
    </div>
  );
};

export default Home;